import React, { CSSProperties } from 'react';

interface ITeamSettingsTabProps {
  enableLeagues: boolean;
  onEnableLeaguesChange: (enabled: boolean) => void;
  showDailyTeamParticipationBonus: boolean;
  enableDailyTeamParticipationBonus: boolean;
  onEnableDailyTeamParticipationBonusChange: (enabled: boolean) => void;
  dailyTeamParticipationBonusMaxXp: number | undefined;
  onDailyTeamParticipationBonusMaxXpChange: (value: number | undefined) => void;
}

const TeamSettingsTab: React.FC<ITeamSettingsTabProps> = ({
  enableLeagues,
  onEnableLeaguesChange,
  showDailyTeamParticipationBonus,
  enableDailyTeamParticipationBonus,
  onEnableDailyTeamParticipationBonusChange,
  dailyTeamParticipationBonusMaxXp,
  onDailyTeamParticipationBonusMaxXpChange,
}) => (
  <div style={styles.container}>
    <h1>Team Settings</h1>
    <div style={styles.columns}>
      <div style={styles.leftColumn}>
        <div style={styles.field}>
          <label style={styles.label}>
            <input
              type='checkbox'
              checked={enableLeagues}
              onChange={() => onEnableLeaguesChange(!enableLeagues)}
              style={styles.checkbox}
            />
            Enable Leagues
          </label>
        </div>
        <div style={styles.field}>
          <label style={styles.label}>
            <input
              type='checkbox'
              checked={false}
              // onChange={() => {}}
              style={styles.checkbox}
              disabled
            />
            Automatic Leagues
          </label>
        </div>
        {showDailyTeamParticipationBonus && (
          <div style={styles.bonusSection}>
            <div style={styles.field}>
              <label style={styles.label}>
                <input
                  type='checkbox'
                  checked={enableDailyTeamParticipationBonus}
                  onChange={() => onEnableDailyTeamParticipationBonusChange(
                    !enableDailyTeamParticipationBonus,
                  )}
                  style={styles.checkbox}
                />
                Enable daily team participation bonus
              </label>
            </div>
            {enableDailyTeamParticipationBonus && (
              <>
                <div style={styles.rightField}>
                  <label style={styles.numberLabel}>
                    Daily team participation bonus maximum XP
                  </label>
                  <input
                    type='number'
                    name='dailyTeamParticipationBonusMaxXp'
                    min={1}
                    step={1}
                    required
                    value={dailyTeamParticipationBonusMaxXp ?? ''}
                    onChange={(e) => onDailyTeamParticipationBonusMaxXpChange(
                      e.target.value === '' ? undefined : Number(e.target.value),
                    )}
                    style={styles.maxXpInput}
                  />
                  <p style={styles.helpText}>
                    Each team member earns a whole-XP amount up to this max per day,
                    scaled by current members (opted in with an active plan) as a
                    percentage of the team&apos;s target size.
                  </p>
                </div>
                <p style={styles.helpText}>
                  Open each team in Team Management and set a target size so the
                  bonus can apply to that team. Leave a team&apos;s target size blank
                  to exclude it. Target size is for bonus fill only; score division
                  uses current members.
                </p>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  </div>
);

const styles: { [key: string]: CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  columns: {
    display: 'flex',
    gap: '48px',
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flex: 1,
  },
  field: {
    display: 'flex',
    alignItems: 'center',
  },
  rightField: {
    display: 'flex',
    alignItems: 'start',
    flexDirection: 'column',
  },
  bonusSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '8px',
    paddingTop: '12px',
    borderTop: '1px solid #ddd',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.95rem',
    cursor: 'pointer',
  },
  checkbox: {
    marginRight: '8px',
    cursor: 'pointer',
  },
  numberLabel: {
    display: 'flex',
    alignItems: 'center',
    color: 'black',
    fontSize: '0.95rem',
    gap: '8px',
  },
  maxXpInput: {
    width: '100px',
    padding: '4px',
    fontSize: '0.95rem',
  },
  helpText: {
    margin: '4px 0 0',
    fontSize: '0.85rem',
    color: '#666',
    maxWidth: '420px',
  },
};

export default TeamSettingsTab;
